import { render, staticRenderFns } from "./Newcommodity.vue?vue&type=template&id=b83652ae&scoped=true"
import script from "./Newcommodity.vue?vue&type=script&lang=js"
export * from "./Newcommodity.vue?vue&type=script&lang=js"
import style0 from "./Newcommodity.vue?vue&type=style&index=0&id=b83652ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83652ae",
  null
  
)

export default component.exports